import { Injectable, ViewContainerRef, inject } from '@angular/core';
import { MfaSettingsModalComponent } from '../../../auth/component/mfa-settings-modal/mfa-settings-modal.component';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private location = inject(Location);

  openMfaSettingsModal(viewContainerRef: ViewContainerRef) {
    // viewContainerRef.clear();
    viewContainerRef.createComponent(MfaSettingsModalComponent);
  }
}
